/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const barriers = useStore((state) => state.barriers);
  const setBarriers = useStore((state) => state.setBarriers);
  const [next, setNext] = useState(barriers.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setBarriers(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.barriers.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={barriers} onChange={handleChange}>
          <MultiOption value={'No time'}>
            <span>⏰</span> {t('onboarding.barriers.options.noTime')}
          </MultiOption>
          <MultiOption value={'Low energy'}>
            <span>😩</span> {t('onboarding.barriers.options.lowEnergy')}
          </MultiOption>
          <MultiOption value={'No ideas what to cook'}>
            <span>🍲</span> {t('onboarding.barriers.options.noIdeas')}
          </MultiOption>
          <MultiOption value={"Not sure what's healthy"}>
            <span>🤔</span> {t('onboarding.barriers.options.notSureHealthy')}
          </MultiOption>
          <MultiOption value={'Stress eating'}>
            <span>💥</span> {t('onboarding.barriers.options.stressEating')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.barriers.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'barriers',
              answer: barriers.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
